<template>
   <fixed-header :threshold="186">
      <div class="it-header-wrapper it-header-sticky">
         <div class="it-header-slim-wrapper" :class="{ 'd-none': isActive }">
            <div class="container">
               <div class="row">
                  <div class="col-12">
                     <div class="it-header-slim-wrapper-content">
                        <a class="navbar-brand" href="https://www.regione.sardegna.it" title="Regione Autonoma della Sardegna">Regione Autonoma della Sardegna</a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="it-nav-wrapper">
            <div class="it-header-center-wrapper">
               <div class="container">
                  <div class="row">
                     <div class="col-12">
                        <div class="it-header-center-content-wrapper">
                           <div class="it-brand-wrapper">
                              <a href="/" title="Programma S3 Sardegna">
                                 <div class="it-brand-text">
                                    <h2 class="no_toc">Programma S3 <span>Sardegna</span></h2>
                                 </div>
                              </a>
                           </div>
                           <div class="it-right-zone">
                              <a href="https://www.regione.sardegna.it/" class="d-none d-lg-inline "><img src="@/assets/img/ras-logo.svg" alt="Regione Autonoma della Sardegna" class="ras-logo"/></a>
                              <div class="it-search-wrapper d-flex d-lg-none" @click="!isSearch ? $refs.searchGeneric.toggleModal()  : null">
                                 <span class="d-none d-md-block">Cerca</span>
                                 <a class="search-link rounded-icon" href="#" aria-label="Cerca" >                                   
                                    <svg class="icon">
                                       <use xlink:href="@/assets/img/sprite.svg#it-search"></use>
                                    </svg>
                                 </a>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div class="it-header-navbar-wrapper">
               <div class="container">
                  <div class="row">
                     <div class="col-12">
                        <nav class="navbar navbar-expand-lg has-megamenu">
                           <button class="custom-navbar-toggler" type="button" @click="expanded = !expanded" name="navbar-toggler">
                              <svg class="icon">
                                 <use xlink:href="img/sprite.svg#it-burger"></use>
                              </svg>
                           </button>
                           <div class="navbar-collapsable" id="nav10" v-bind:class="{ 'expanded d-block': isActive }">
                              <div class="overlay" @click="expanded = !expanded"></div>
                              <div class="close-div">
                                 <h5 class="h3 no_toc pl-2 d-inline">Programma <span class="font-weight-normal">S3 Sardegna</span></h5>
                                 <button class="btn close-menu" type="button" @click="expanded = !expanded" name="close-menu">
                                    <svg class="icon"><use xlink:href="@/assets/img/sprite.svg#it-close-big "></use></svg>
                                 </button>
                              </div>
                              <div class="menu-wrapper">
                                 <div class="it-brand-wrapper cloned">
                                    <a href="/" title="Programma S3 Sardegna" class="d-none d-md-block">
                                       <div class="it-brand-text">
                                          <h2 class="no_toc">Programma <span>S3 Sardegna</span></h2>
                                       </div>
                                    </a>
                                 </div>      

                                 <main-menu :top="true" v-bind:menuList="menuList" @clicked="onClickChild" v-on:clickedMenuItem="onClickChild" />
                                    
                                 <div class="d-none d-lg-flex">
                                    <div class="it-search-wrapper" @click="!isSearch ? $refs.searchGeneric.toggleModal()  : null">
                                       <span class="d-none d-md-block">Cerca</span>
                                       <div class="search-link rounded-icon">
                                          <a class="search-link rounded-icon" v-b-modal.modal-1  name="apriRicerca">
                                             <svg class="icon">
                                                <use xlink:href="@/assets/img/sprite.svg#it-search"></use>
                                             </svg>
                                          </a>
                                       </div> 
                                    </div>     
                                 </div>

                              </div>
                           </div>
                        </nav>
                     </div>
                  </div>
               </div>
            </div>

            <searchGeneric v-bind:where="`header`" v-bind:title="`Cerca`" ref="searchGeneric"/>

         </div>
      </div>
   </fixed-header>
</template>
<script>
import MainMenu from "@/components/MainMenu";
import SearchGeneric from "@/components/SearchGeneric.vue";
import FixedHeader from 'vue-fixed-header';

export default {
	components: {
      FixedHeader,
		MainMenu,
      SearchGeneric,
	},
   props: {
      menuList: {
         type: Array,
         description: "menuItems as array"
      }      
   },   
   data() {
      return {
         expanded: false,
         active: false,
      }
   },
   methods: {
      onClickChild () {
         this.expanded = false;
         this.active = false;
      }      
   },
   computed: {
      isActive() {
         return this.expanded;
      },
      isSearch() {
        return this.$route.name === 'Cerca'
      }
   }
};
</script>
<style >
.it-brand-wrapper.cloned{
   display:none;
}
.it-header-sticky.vue-fixed-header--isFixed .it-brand-wrapper.cloned{
   transition: all 1s ease;
   display:block;
}
.navbar-collapsable.expanded{
   display:block;
   transition: all 1s ease;
   font-size:1.4rem;
}
.navbar-collapsable.expanded .overlay{
   display:block;
   transition: all 1s ease;
}
.tab-content #checkbox-argomenti-generic, .tab-content #checkbox-argomenti{
   column-count: 3;
}

@media screen and (max-width: 998px) {
   .modal .modal-dialog{
      max-width: 800px;
   }
   .tab-content #checkbox-argomenti-generic, .tab-content #checkbox-argomenti{
      column-count: 1;
   }
   #applyFilterBtn{
      margin-bottom: 20px;
      margin-right: 20px;
   }
   #filterTabs .tabs .nav-tabs{
      flex-direction: column !important;
   }
}
.modal .modal-dialog{
   min-width: 350px;
}
</style> 
